import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AgreementProvider } from './context/AgreementContext';
import { WelcomePage } from './components/WelcomePage';
import { AgreementWizard } from './components/AgreementWizard';
import { PaymentOptions } from './components/PaymentOptions';
import { ConfirmationScreen } from './components/ConfirmationScreen';
import { SignatureSuccessPage } from './components/SignatureSuccessPage';
import { SecondarySignerView } from './components/SecondarySignerView';
import { StatusGuard } from './components/StatusGuard';

// Component to redirect to main SearchProperty website
function RedirectToMainSite() {
  useEffect(() => {
    // Redirect to the main SearchProperty website
    window.location.href = 'https://searchproperty.com.au';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to SearchProperty.com.au...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <AgreementProvider>
      <div className="min-h-screen bg-gray-100">
        <Routes>
          {/* Agreement-specific routes - the site will always be accessed with an agreement_id */}
          <Route
            path="/:agreement_id"
            element={
              <StatusGuard allowedStatuses={['sent', 'reviewed', 'pending', 'signed', 'confirmed']}>
                <WelcomePage />
              </StatusGuard>
            }
          />
          <Route
            path="/:agreement_id/start-agreement"
            element={
              <StatusGuard allowedStatuses={['reviewed', 'pending', 'signed', 'confirmed']}>
                <AgreementWizard />
              </StatusGuard>
            }
          />
          <Route
            path="/:agreement_id/payment"
            element={
              <StatusGuard allowedStatuses={['confirmed']}>
                <PaymentOptions />
              </StatusGuard>
            }
          />
          <Route
            path="/:agreement_id/confirmation"
            element={
              <StatusGuard allowedStatuses={['completed']} redirectOnCompleted={false}>
                <ConfirmationScreen />
              </StatusGuard>
            }
          />
          
          {/* Secondary signer routes - these don't need status guards */}
          <Route path="/sign/:signature_id" element={<SecondarySignerView />} />
          <Route path="/signature-success" element={<SignatureSuccessPage />} />
          
          {/* Root route redirect to main website */}
          <Route 
            path="/" 
            element={<RedirectToMainSite />} 
          />
          
          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </AgreementProvider>
  );
}

export default App;